import NatSessionRepo, {
    ChangeBelongCondominiumGroupResponse,
    PostAdminCondominiumSelectParams,
    ResidentLoginInfoBean,
} from '../__NoAutomatedTests/components/session/repository/NatSessionRepo'
import NatMenuMasterRepo from '../__NoAutomatedTests/components/menuMaster/repository/NatMenuMasterRepo'
import EventEmitterExAdmin from '../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AsyncCallFunctionType} from '../components/shared/hoc/withAsyncCommunication'
import {Nullable} from './TypeHelpers'
import {
    NatPostAdminCondominiumSelect,
} from '../__NoAutomatedTests/components/session/repository/NatPostAdminCondominiumSelect'
import {
    NatAdminLoginInfoSessionStorageHelper,
} from '../__NoAutomatedTests/common/authentication/NatAdminLoginInfoSessionStorageHelper'
import {
    NatGetMenuMasterAuthedAdmin,
} from '../__NoAutomatedTests/components/menuMaster/repository/NatGetMenuMasterAuthedAdmin'
import {Messages} from '../Messages'
import {SessionStorageHelper} from '../SessionStorageHelper'
import {NatPostAdminOverallSelect} from '../__NoAutomatedTests/components/session/repository/NatPostAdminOverallSelect'
import AdminAuthRepository from '../__NoAutomatedTests/components/login/repository/AdminAuthRepository'
import {CondominiumGroup} from '../components/header/AdminHeaderAreaComponent'
import {isMobile} from 'react-device-detect'
import {resetViewport} from '../common/util/ViewportUtils'
import {
    NatResidentLoginInfoSessionStorageHelper,
} from '../__NoAutomatedTests/common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {NavigateFunction} from 'react-router-dom'
import {NatAsyncCallFunction} from '../__NoAutomatedTests/common/util/Natutil';
import NatResidentUserRepo from '../__NoAutomatedTests/components/residentUser/repository/NatResidentUserRepo';
import {NatCreateLogoutUrl} from '../__NoAutomatedTests/components/residentUser/repository/NatCreateLogoutUrl';
import {ROLE_FOR_ADMINISTRATOR} from '../CodeMaster';

export const ADMIN_LOGIN_PORTAL_PATH = '/admin/login-portal'

const KEY_CONDOMINIUM_SEARCH_CONDITION: string = 'adminCondominiumListPageSearchCondition'
const KEY_APART_ASSOC_SEARCH_CONDITION: string = 'adminApartAssocListPageSearchCondition'
const KEY_LIFENOTE_SEARCH_CONDITION: string = 'adminLifeNoteListPageSearchCondition'
const KEY_MESSAGE_SEARCH_CONDITION: string = 'adminMessageListPageSearchCondition'
const KEY_SCHEDULE_SEARCH_CONDITION: string = 'adminSchedulePageSearchCondition'
const KEY_RESIDENT_USER_SEARCH_CONDITION: string = 'adminResidentUserListPageSearchCondition'
const KEY_ADMIN_USER_SEARCH_CONDITION: string = 'adminAdminUserListPageSearchCondition'
const KEY_ADDITIONAL_BILLING_SEARCH_CONDITION: string = 'adminAdditionalBillingListPageSearchCondition'
const KEY_FACILITY_RESERVE_SEARCH_CONDITION: string = 'adminFacilityReserveListPageSearchCondition'
const KEY_AREA_CODE_SEARCH_CONDITION: string = 'adminAreaCodeListPageSearchCondition'
const KEY_RESIDENT_USER_LIST_SEARCH_CONDITION: string = 'adminExtractHistoryPageSearchCondition'
const KEY_RESIDENT_USER_APPLY_LIST_SEARCH_CONDITION: string = 'adminResidentUserApplyListPageSearchCondition'
const KEY_RESIDENT_USER_STATUS_LIST_SEARCH_CONDITION: string = 'adminResidentUserStatusListPageSearchCondition'
const KEY_APPLY_STATUS_LIST_SEARCH_CONDITION: string = 'applyStatusListSearchCondition'
export const KEY_ASSOC_TERM_LIST_SEARCH_CONDITION: string = 'adminAssocTermListPageSearchCondition'
export const KEY_ASSOC_DIRECTOR_LIST_SEARCH_CONDITION: string = 'adminAssocDirectorListPageSearchCondition'
export const KEY_MEETING_LIST_SEARCH_CONDITION: string = 'adminMeetingListPageSearchCondition'
export const KEY_MEETING_NOTIFICATION_RECEIVE_LIST_SEARCH_CONDITION: string = 'adminMeetingNotificationReceiveListPageSearchCondition'
const KEY_OWNERSHIP_TRANSFER_LIST_SEARCH_CONDITION: string = 'ownershipTransferListSearchCondition'
export const KEY_ASSOC_STATUS_LIST_SEARCH_CONDITION: string = 'adminAssocStatusListPageSearchCondition'
const KEY_USER_REGISTRATION_APPLY_LIST_SEARCH_CONDITION: string = 'userRegistrationApplyListSearchCondition'
export const KEY_ADMIN_DISASTER_COMMENT_LIST_SEARCH_CONDITION: string = 'adminDisasterCommentListSearchCondition'
export const KEY_ADMIN_DISASTER_TOPIC_LIST_SEARCH_CONDITION: string = 'adminDisasterTopicListSearchCondition'
const KEY_DISASTER_MODE_STATUS_LIST_SEARCH_CONDITION: string = 'disasterModeStatusListSearchCondition'
export const KEY_UNIT_OWNER_LIST_ASSOC_ID: string = 'adminUnitOwnerListPageAssocId'
export const KEY_UNIT_OWNER_LIST_SEARCH_CONDITION: string = 'adminUnitOwnerListPageSearchCondition'
export const KEY_GENERAL_MEETING_LIST_SEARCH_CONDITION: string = 'adminGeneralMeetingListPageSearchCondition'

const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    eventEmitter: EventEmitterExAdmin
    asyncCallFunction: AsyncCallFunctionType
    navigate: NavigateFunction
    residentUserRepo: NatResidentUserRepo
}

export class AdminSessionUtil {
    adminAuthRepo: AdminAuthRepository
    sessionRepo: NatSessionRepo
    menuMasterRepo: NatMenuMasterRepo
    roleId: Nullable<string>

    constructor(
        adminAuthRepo: AdminAuthRepository,
        sessionRepo: NatSessionRepo,
        menuMasterRepo: NatMenuMasterRepo,
    ) {
        this.adminAuthRepo = adminAuthRepo
        this.sessionRepo = sessionRepo
        this.menuMasterRepo = menuMasterRepo

        this.roleId = SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)
    }

    async setAllMode(
        props: Props,
        postProcess?: () => void,
    ): Promise<void> {
        const response: Nullable<NatPostAdminOverallSelect> = await props.asyncCallFunction(
            this.sessionRepo.postAdminOverallSelect.bind(this.sessionRepo),
            (httpErrorOrNetworkError) => {
                props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )

        if (response && !response.requestError) {
            NatAdminLoginInfoSessionStorageHelper.setSessionStorageForAllMode(response.authority)

            if (postProcess) {
                postProcess()
            }

            await this.moveTopPage(props)
        }
    }

    async setCondominiumMode(
        props: Props,
        selectedCondominiumInfo: { condominiumCd: string; condominiumName: string },
        postProcess?: () => void,
    ): Promise<void> {
        await props.eventEmitter.showLoading()
        try {
            const request: PostAdminCondominiumSelectParams = {
                condominiumCd: selectedCondominiumInfo.condominiumCd,
            }
            const response: Nullable<NatPostAdminCondominiumSelect> =
                await props.asyncCallFunction(
                    this.sessionRepo.postAdminCondominiumSelect.bind(this.sessionRepo, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(props.eventEmitter)
                    },
                )

            if (response && !response.requestError) {
                NatAdminLoginInfoSessionStorageHelper.setSessionStorageForCondominiumMode(
                    response.authority,
                    selectedCondominiumInfo.condominiumCd,
                    selectedCondominiumInfo.condominiumName,
                )

                if (postProcess) {
                    postProcess()
                }

                await this.moveTopPage(props)
            }
        } finally {
            props.eventEmitter.closeLoading()
        }
    }

    async switchCondominiumGroup(
        props: Props,
        newCondominiumGroup: CondominiumGroup,
        postProcess?: () => void,
    ): Promise<void> {
        await props.eventEmitter.showLoading()
        try {
            const changeBelongCondominiumGroupResponse: Nullable<ChangeBelongCondominiumGroupResponse> =
                await props.asyncCallFunction(
                    this.sessionRepo.changeBelongCondominiumGroup.bind(this.sessionRepo, newCondominiumGroup.id),
                    (httpErrorOrNetworkError) => {
                        props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
            if (!changeBelongCondominiumGroupResponse) {
                return
            }

            NatAdminLoginInfoSessionStorageHelper.setSessionStorageForChangeBelongCondominiumGroup(
                newCondominiumGroup.id,
                newCondominiumGroup.name,
                changeBelongCondominiumGroupResponse.authorities,
            )

            if (postProcess) {
                postProcess()
            }
        } finally {
            props.eventEmitter.closeLoading()
        }
    }

    async logout(
        props: Props,
    ): Promise<void> {
        await props.eventEmitter.showLoading()

        this.roleId = SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)

        if (this.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value) {
            try {
                // ログアウト
                // アプリの場合はreturn
                const isSutekiNetSmartPhoneApplication = SessionStorageHelper
                    .getStringItemWithDefault('isSutekiNetSmartPhoneApplication', 'false')

                if (isSutekiNetSmartPhoneApplication === 'true') {
                    return;
                }
                // 新G基盤ログアウト要求URL作成
                const natCreateLogoutUrl: Nullable<NatCreateLogoutUrl> =
                    await NatAsyncCallFunction(
                        props.residentUserRepo.createLogout.bind(
                            props.residentUserRepo), props.navigate);
                if (natCreateLogoutUrl && natCreateLogoutUrl.details) {
                    // 新G基盤ログアウト要求
                    window.location.href = natCreateLogoutUrl.details;
                }

            } finally {
                props.eventEmitter.closeLoading()
            }
        } else {
            try {
                await props.asyncCallFunction(
                    this.adminAuthRepo.logout.bind(this.adminAuthRepo),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(props.eventEmitter)
                    },
                )
            } finally {
                props.eventEmitter.closeLoading()
                // セッションストレージを全削除
                SessionStorageHelper.removeAllItem()
                props.navigate(ADMIN_LOGIN_PORTAL_PATH)
            }
        }
    }

    async changeLoginSiteToResident(
        props: Props,
    ): Promise<void> {
        await props.eventEmitter.showLoading()
        try {
            const loginInfo: Nullable<ResidentLoginInfoBean> =
                await props.asyncCallFunction(
                    this.sessionRepo.changeLoginSiteToResident.bind(this.sessionRepo),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(props.eventEmitter)
                    },
                )

            if (loginInfo === null) {
                return
            }

            if (isMobile) {
                resetViewport()
            }

            SessionStorageHelper.removeAllItem()

            NatResidentLoginInfoSessionStorageHelper.setSessionStorageMailAddressDomain(null)
            if (loginInfo.mailAddressPc) {
                NatResidentLoginInfoSessionStorageHelper.setSessionStorageMailAddressDomain(loginInfo.mailAddressPc)
            } else if (loginInfo.mailAddressMb) {
                NatResidentLoginInfoSessionStorageHelper.setSessionStorageMailAddressDomain(loginInfo.mailAddressMb)
            }

            if (loginInfo && loginInfo.role) {
                // 所属物件が1件の場合
                NatResidentLoginInfoSessionStorageHelper.setSessionStorage(loginInfo)
                props.navigate('/resident/mypage')
            } else {
                // 所属物件が複数の場合
                NatResidentLoginInfoSessionStorageHelper.setSessionStorage(loginInfo)
                props.navigate('/resident/condominiumSelect')
            }
        } finally {
            props.eventEmitter.closeLoading()
        }
    }

    async moveTopPage(props: Props): Promise<void> {
        this.deleteSearchConditions()

        // 一番左（最初）のメニューを取得
        const menuInfo: Nullable<NatGetMenuMasterAuthedAdmin> = await props.asyncCallFunction(
            this.menuMasterRepo.getMenuMasterAuthedAdmin.bind(this.menuMasterRepo),
            (httpErrorOrNetworkError) => {
                props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        if (menuInfo &&
            menuInfo.details &&
            menuInfo.details[0] &&
            menuInfo.details[0].childMenuInfo &&
            menuInfo.details[0].childMenuInfo[0]) {
            window.location.href = menuInfo.details[0].childMenuInfo[0].url
        } else {
            // メニューが取得できない場合はエラー画面へ
            props.navigate(
                '/admin/error',
                {state: {message: Messages.EOPCC0042.toString('管理者様向けサービス')}},
            )
        }
    }

    // 検索条件の破棄
    deleteSearchConditions(): void {
        SessionStorageHelper.removeItem(KEY_CONDOMINIUM_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_APART_ASSOC_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_LIFENOTE_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_MESSAGE_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_SCHEDULE_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_RESIDENT_USER_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_ADMIN_USER_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_ADDITIONAL_BILLING_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_FACILITY_RESERVE_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_AREA_CODE_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_RESIDENT_USER_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_RESIDENT_USER_APPLY_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_RESIDENT_USER_STATUS_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_APPLY_STATUS_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_ASSOC_TERM_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_ASSOC_DIRECTOR_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_MEETING_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_MEETING_NOTIFICATION_RECEIVE_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_OWNERSHIP_TRANSFER_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_ASSOC_STATUS_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_USER_REGISTRATION_APPLY_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_ADMIN_DISASTER_COMMENT_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_ADMIN_DISASTER_TOPIC_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_DISASTER_MODE_STATUS_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_UNIT_OWNER_LIST_ASSOC_ID)
        SessionStorageHelper.removeItem(KEY_UNIT_OWNER_LIST_SEARCH_CONDITION)
        SessionStorageHelper.removeItem(KEY_GENERAL_MEETING_LIST_SEARCH_CONDITION)
    }
}
